export let pip = 0.0001
export let ORDER_LONG = "LONG"
export let ORDER_SHORT = "SHORT"